import moment from "moment"

const dealMemoReducerDefaultState = {
  usersRolesArray: [],
  usersRolesArrayInitialValues: [],
  expensesTypesList: [],
  generalData: {},
  classesList: [],
  recallInvoice: false
}

export default (state = dealMemoReducerDefaultState, action) => {
  switch (action.type) {
    //SET DATA
    case "DEAL_MEMO::SET_ROLES_USERS_ARRAY":
      return {
        ...state,
        usersRolesArray: action.data,
      }
    case "DEAL_MEMO::SET_ROLES_USERS_ARRAY_INITIAL_VALUES":
      return {
        ...state,
        usersRolesArrayInitialValues: action.data,
      }
    case "RECALL::INVOICE_FOR_CLIENT":
      return {
        ...state,
        recallInvoice: action.data,
      }
    case "DEAL_MEMO::SET_GENERAL_DATA":
      return {
        ...state,
        generalData: action.data,
      }
    case "DEAL_MEMO::SET_EXPENSES_TYPES":
      return {
        ...state,
        expensesTypesList: action.data,
      }
    case "DEAL_MEMO::SET_CLASSES_LIST":
      return {
        ...state,
        classesList: action.data,
      }
    case "DEAL_MEMO::REORDER_ROLES_USERS_ARRAY":
      let newUsersArrayForReorder = state.usersRolesArray.map(role => {
        let newRole = { ...role }
        const newExpenses = action.data.filter(x => x.expense_id)
        const newAdditionalExepenses = action.data.filter(
          x => x.additional_expense_id
        )

        if (
          Number(newRole.id || newRole.shoot_role) ===
          Number(action.shootRoleId)
        ) {
          if (action.data) {
            if (newExpenses.length > 0) {
              newRole.expenses = [...newExpenses]
            }
            if (newAdditionalExepenses.length > 0) {
              newRole.additional_expenses = [...newAdditionalExepenses]
            }
          }
          return newRole
        } else {
          return role
        }
      })

      return {
        ...state,
        usersRolesArray: newUsersArrayForReorder,
      }
    //CREATE DATA
    case "DEAL_MEMO::ADD_EXPENSE_ITEM":
      let newUsersArray = state.usersRolesArray.map(role => {
        let newRole = { ...role }
        if (
          Number(newRole.id || newRole.shoot_role) ===
          Number(action.data.shootRoleId)
        ) {
          if (action.data.additional_expense_id) {
            newRole.additional_expenses = [
              ...newRole.additional_expenses,
              action.data,
            ]
          } else {
            newRole.expenses = [...newRole.expenses, action.data]
          }
          return newRole
        } else {
          return role
        }
      })

      return {
        ...state,
        usersRolesArray: newUsersArray,
      }
    case "DEAL_MEMO::ADD_EXPENSE_ITEM_INITIAL_VALUES":
      let newUsersArrayIntialValues = state.usersRolesArrayInitialValues.map(
        role => {
          let newRole = { ...role }
          if (
            Number(newRole.id || newRole.shoot_role) ===
            Number(action.payload.response.data[0].shoot_role)
          ) {
            if (action.payload.response.data[0].additional_expense_id) {
              newRole.additional_expenses = [
                ...newRole.additional_expenses,
                action.payload.response.data[0],
              ]
            } else {
              newRole.expenses = [
                ...newRole.expenses,
                action.payload.response.data[0],
              ]
            }
            return newRole
          } else {
            return role
          }
        }
      )
      return {
        ...state,
        usersRolesArrayInitialValues: newUsersArrayIntialValues,
      }

    case "DEAL_MEMO::ADD_ADDITIONAL_EXPENSE_ITEM_INITIAL_VALUES":
      let newUsersArrayIntialValues2 = state.usersRolesArrayInitialValues.map(
        role => {
          let newRole = { ...role }
          if (
            Number(newRole.id || newRole.shoot_role) ===
            Number(action.payload.response.data[0].shoot_role)
          ) {
            newRole.additional_expenses = [
              ...newRole.additional_expenses,
              action.payload.response.data[0],
            ]
            return newRole
          } else {
            return role
          }
        }
      )
      return {
        ...state,
        usersRolesArrayInitialValues: newUsersArrayIntialValues2,
      }

    case "DEAL_MEMO::ADD_ADDITIONAL_EXPENSE_ITEM":
      let newUsersArrayWithAdditionalItem = state.usersRolesArray.map(role => {
        let newRole = { ...role }
        if (
          Number(newRole.id || newRole.shoot_role) ===
          Number(action.data.shootRoleId)
        ) {
          newRole.additional_expenses = [
            ...newRole.additional_expenses,
            action.data.expenseData,
          ]
          return newRole
        } else {
          return role
        }
      })
      return {
        ...state,
        usersRolesArray: newUsersArrayWithAdditionalItem,
      }
    //UPDATE DATA
    case "DEAL_MEMO::TOGGLE_FLAG_EXPENSE":
      let { expenseId, shootRole, additional_expenses, type } = action.data
      // type --> used to switch status id into status string
      // shootRole --> find the crew member you need
      // expenseId --> targeting the given expense or additional expense by id
      // additional_expenses --> bool: false for expense, true for additional so you're mapping the correct array

      // type_flag_status_id = if 4 flagged, else accepted
      let newStatus =
        action.data[`${type}_flag_status_id`] === 4 ? "flagged" : "accepted"

      let newRolesArray = state.usersRolesArray.map(role => {
        let newRole = { ...role }
        if (shootRole === newRole.id || newRole.shoot_role) {
          if (additional_expenses) {
            newRole.additional_expenses = newRole.additional_expenses.map(
              addExp => {
                let newAddExp = { ...addExp }
                if (newAddExp.additional_expense_id === expenseId) {
                  return {
                    ...newAddExp,
                    [`${type}_flag_status`]: newStatus,
                    [`${type}_flag_comment`]: action.data[
                      `${type}_flag_comment`
                    ],
                  }
                } else {
                  return addExp
                }
              }
            )
          } else {
            newRole.expenses = newRole.expenses.map(exp => {
              let newExp = { ...exp }
              if (newExp.expense_id === expenseId) {
                return {
                  ...newExp,
                  [`${type}_flag_status`]: newStatus,
                  [`${type}_flag_comment`]: action.data[`${type}_flag_comment`],
                }
              } else {
                return exp
              }
            })
          }
        }
        return newRole
      })
      return {
        ...state,
        usersRolesArray: newRolesArray,
      }
    case "DEAL_MEMO::UPDATE_SENT_CLIENT_INVOICE_ESTIMATE":
      let documentType = action.documentType
      let recipients = action.recipients
      return {
        ...state,
        generalData: {
          ...state.generalData,
          [`${documentType}_sent`]: 1,
          [`${documentType}_sent_date_time`]: moment().format(),
          [`${documentType}_sent_to`]: recipients,
        },
      }

    case "DEAL_MEMO::UPDATE_ACCEPTED_CLIENT_INVOICE_ESTIMATE":
      let documentType2 = action.data.type
      return {
        ...state,
        generalData: {
          ...state.generalData,
          ...action.data,
          [`${documentType2}_accepted`]: 1,
          [`${documentType2}_accepted_date_time`]: moment().format(),
        },
      }
    case "UPDATE_ANY_KEY_IN_GENERAL_DATA":
      return {
        ...state,
        generalData: {
          ...state.generalData,
          ...action.payload,
        },
      }
    case "DEAL_MEMO::UPDATE_EXPENSE_ITEM":
      let newUsersRoles1 = state.usersRolesArray.map(user => {
        let newUser = { ...user }
        if (newUser.shoot_role || newUser.id === action.data.shootRoleId) {
          newUser.expenses = newUser.expenses.map(expense => {
            let newExpense = { ...expense }
            if (newExpense.expense_id === action.data.id) {
              newExpense = { ...newExpense, ...action.data }
              newExpense.expense_id = action.data.id
              return newExpense
            } else {
              return expense
            }
          })
          return newUser
        } else {
          return user
        }
      })
      return {
        ...state,
        usersRolesArray: newUsersRoles1,
      }

    case "DEAL_MEMO::UPDATE_EXPENSE_ITEM_INITIAL_VALUES":
      let newUsersRolesInitialValues = state.usersRolesArrayInitialValues.map(
        user => {
          let newUser = { ...user }
          if (newUser.shoot_role || newUser.id === action.data.shootRoleId) {
            newUser.expenses = newUser.expenses.map(expense => {
              let newExpense = { ...expense }
              if (newExpense.expense_id === action.data.id) {
                newExpense = { ...newExpense, ...action.data }
                newExpense.expense_id = action.data.id
                return newExpense
              } else {
                return expense
              }
            })
            return newUser
          } else {
            return user
          }
        }
      )
      return {
        ...state,
        usersRolesArrayInitialValues: newUsersRolesInitialValues,
      }

    case "DEAL_MEMO::UPDATE_ADDITIONAL_EXPENSE_ITEM_INITIAL_VALUES":
      let newAdditionalUsersRolesInitialValues = state.usersRolesArrayInitialValues.map(
        user => {
          let newUser = { ...user }
          if (newUser.shoot_role || newUser.id === action.data.shootRoleId) {
            newUser.additional_expenses = newUser.additional_expenses.map(
              additionalExpense => {
                let newAdditionalExpense = { ...additionalExpense }
                if (newAdditionalExpense.expense_id === action.data.id) {
                  newAdditionalExpense = {
                    ...newAdditionalExpense,
                    ...action.data,
                  }
                  return newAdditionalExpense
                } else {
                  return additionalExpense
                }
              }
            )
            return newUser
          } else {
            return user
          }
        }
      )
      return {
        ...state,
        usersRolesArrayInitialValues: newAdditionalUsersRolesInitialValues,
      }

    case "DEAL_MEMO::UPDATE_EXPENSE_ITEM_UUID_TO_RESPONSE_ID":
      let newUsers2 = state.usersRolesArray.map(user => {
        let newUser = { ...user }
        if (
          newUser.shoot_role ||
          newUser.id === action.payload.response.data[0].shoot_role
        ) {
          newUser.expenses = newUser.expenses.map(expense => {
            let newExpense = { ...expense }
            if (
              newExpense.expense_id ===
              action.payload.createdItem.data[0].expense_id
            ) {
              newExpense = action.payload.response.data[0]
              newExpense.type_name =
                action.payload.createdItem.data[0].type_name
              newExpense.expense_id = action.payload.response.data[0].id
              return newExpense
            } else {
              return expense
            }
          })
          return newUser
        } else {
          return user
        }
      })
      return {
        ...state,
        usersRolesArray: newUsers2,
      }

    case "UPDATE_DEAL_MEMO_ADDITIONAL_EXPENSE_ITEM":
      let newUsersRoles5 = state.usersRolesArray.map(user => {
        let newUser = { ...user }
        if (newUser.shoot_role || newUser.id === action.data.shootRoleId) {
          newUser.additional_expenses = newUser.additional_expenses.map(
            additonalexpense => {
              let newAdditionalExpense = { ...additonalexpense }
              if (
                newAdditionalExpense.additional_expense_id === action.data.id
              ) {
                newAdditionalExpense = {
                  ...newAdditionalExpense,
                  ...action.data,
                }
                return newAdditionalExpense
              } else {
                return additonalexpense
              }
            }
          )
          return newUser
        } else {
          return user
        }
      })
      return {
        ...state,
        usersRolesArray: newUsersRoles5,
      }
    case "DEAL_MEMO::UPDATE_BATCH_CREW_STATUS":
      state.usersRolesArray = state.usersRolesArray.map(role => {
        let newRole = { ...role }
        newRole.user_status =
          newRole.user_status === "unsent" ? "sent" : newRole.user_status
        newRole.sent_date_time = moment().format()
        return newRole
      })

      return {
        ...state,
        usersRolesArray: state.usersRolesArray,
      }

    case "DEAL_MEMO::UPDATE_ADDITIONAL_EXPENSE_ITEM_UUID_TO_RESPONSE_ID":
      let newUsers3 = state.usersRolesArray.map(user => {
        let newUser = { ...user }
        if (
          newUser.shoot_role ||
          newUser.id === action.payload.response.data[0].shoot_role
        ) {
          newUser.additional_expenses = newUser.additional_expenses.map(
            additionalExpense => {
              let newAdditionalExpense = { ...additionalExpense }
              if (
                newAdditionalExpense.additional_expense_id ===
                action.payload.createdItem.data[0].additional_expense_id
              ) {
                newAdditionalExpense = action.payload.response.data[0]
                newAdditionalExpense.additional_expense_id =
                  action.payload.response.data[0].id
                newAdditionalExpense.type_name =
                  action.payload.createdItem.data[0].type_name
                return newAdditionalExpense
              } else {
                return additionalExpense
              }
            }
          )
          return newUser
        } else {
          return user
        }
      })
      return {
        ...state,
        usersRolesArray: newUsers3,
      }
    case "DEAL_MEMO::UPDATE_CREW_STATUS":
      state.usersRolesArray = state.usersRolesArray.map(user => {
        let newUser = { ...user }
        if (Number(action.shootRoleId) === Number(newUser.shoot_role)) {
          newUser = {
            ...newUser,
            ...action.dataToUpdate,
            user_status: action.propToChange,
            [`${action.propToChange}_date_time`]: moment().format(),
          }
          return newUser
        } else {
          return user
        }
      })
      return {
        ...state,
        usersRolesArray: state.usersRolesArray,
      }

    case "DEAL_MEMO::UPDATE_BILLING_STEP_STATE":
      return {
        ...state,
        generalData: {
          ...state.generalData,
          billing_step: action.data.step,
          billing_step_name: action.data.step_name,
        },
      }
    //DELETE DATA
    case "DEAL_MEMO::DELETE_EXPENSE_ITEM":
      let newUsersArrayAfterDelete = state.usersRolesArray.map(role => {
        role.expenses = role.expenses.filter(
          role => role.expense_id !== action.expense_Id
        )
        return role
      })

      return {
        ...state,
        usersRolesArray: newUsersArrayAfterDelete,
      }
    case "DEAL_MEMO::DELETE_EXPENSE_ITEM_INITIAL_VALUES":
      let newUsersArrayAfterDeleteInitialValues = state.usersRolesArrayInitialValues.map(
        role => {
          role.expenses = role.expenses.filter(
            role => role.expense_id !== action.expense_Id
          )
          return role
        }
      )

      return {
        ...state,
        usersRolesArrayInitialValues: newUsersArrayAfterDeleteInitialValues,
      }

    case "DEAL_MEMO::DELETE_ADDITIONAL_EXPENSE_ITEM_INITIAL_VALUES":
      let newUsersArrayAfterDeleteAdditionalInitialValues = state.usersRolesArrayInitialValues.map(
        role => {
          role.additional_expenses = role.additional_expenses.filter(
            role => role.additional_expense_id !== action.data
          )
          return role
        }
      )

      return {
        ...state,
        usersRolesArrayInitialValues: newUsersArrayAfterDeleteAdditionalInitialValues,
      }

    case "DEAL_MEMO::DELETE_SHOOT_ROLE":
      let newState = state.usersRolesArray.filter(role => {
        if (Number(role.id || role.shoot_role) !== Number(action.shootRoleId)) {
          return role
        }
      })

      return {
        ...state,
        usersRolesArray: newState,
      }

    case "DEAL_MEMO::UNATTACH_USER_ROLE":
      let unattachNewState = state.usersRolesArray.map(role => {
        if (Number(role.id || role.shoot_role) !== Number(action.shootRoleId)) {
          let newRole = role
          return newRole
        } else {
          let newRole = {
            role_id: role.role_id,
            name: role.name,
            shoot_role: role.shoot_role,
            shoot_id: role.shoot_id,
            expenses: [],
            additional_expenses: [],
          }

          return newRole
        }
      })

      return {
        ...state,
        usersRolesArray: unattachNewState,
      }

    case "DEAL_MEMO::UNATTACH_ROLE_SHOOT":
      let unattachRoleNewState = state.usersRolesArray.filter(
        role =>
          Number(role.id || role.shoot_role) !== Number(action.shootRoleId)
      )

      return {
        ...state,
        usersRolesArray: unattachRoleNewState,
      }

    case "DEAL_MEMO::DELETE_ADDITIONAL_EXPENSE_ITEM":
      let newUsersArrayAfterDeleteAdditionalItem = state.usersRolesArray.map(
        role => {
          role.additional_expenses = role.additional_expenses.filter(
            role => role.additional_expense_id !== action.data
          )
          return role
        }
      )
      return {
        ...state,
        usersRolesArray: newUsersArrayAfterDeleteAdditionalItem,
      }

    case "DEAL_MEMO::UPDATE_SHOOTROLE":
      let shootRoleUpdated = (state.usersRolesArray = state.usersRolesArray.map(
        user => {
          let newUser = { ...user }
          if (Number(action.shootRoleId) === Number(newUser.shoot_role)) {
            newUser = {
              ...newUser,
              ...action.data,
            }
            return newUser
          } else {
            return user
          }
        }
      ))

      return {
        ...state,
        usersRolesArray: shootRoleUpdated,
      }

    default:
      return state
  }
}
